import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const Navbar = () => {
  const { authenticated, userInfo, isAdmin, logout } = useAuth();
  const location = useLocation();

  if (!authenticated) {
    return null;
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/dashboard">
          MagisPrev
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                to="/dashboard"
              >
                Dashboard
              </Link>
            </li>

            {isAdmin && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`}
                  to="/admin"
                >
                  <span className="badge bg-warning text-dark me-1">Admin</span>
                  Acesso ao Dashboard
                </Link>
              </li>
            )}

            {isAdmin && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/admin/cortesias' ? 'active' : ''}`}
                  to="/admin/cortesias"
                >
                  <span className="badge bg-warning text-dark me-1">Admin</span>
                  Cortesias
                </Link>
              </li>
            )}
          </ul>

          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle btn btn-link"
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {userInfo?.name || userInfo?.email || 'Usuario'}
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li>
                  <span className="dropdown-item-text text-muted small">
                    {userInfo?.email}
                  </span>
                </li>
                {userInfo?.roles?.length > 0 && (
                  <li>
                    <span className="dropdown-item-text text-muted small">
                      Roles: {userInfo.roles.join(', ')}
                    </span>
                  </li>
                )}
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button className="dropdown-item" onClick={logout}>
                    Sair
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
